import React from "react";
import { X } from "lucide-react";

const SuccessNotification = ({
  executionStatus,
  showNotification,
  onClose,
}) => {
  if (
    !showNotification ||
    executionStatus?.submissionResults?.status !== "Accepted"
  ) {
    return null;
  }

  const {
    pointsEarned
  } = executionStatus?.submissionResults ?? {};

  return (
    <>
      <style jsx="true">{`
        @import url("https://fonts.googleapis.com/css2?family=Cabin+Sketch:wght@400;700&display=swap");

        .christmas-notification-wrapper {
          position: fixed;
          bottom: 5rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1000;
          animation: festive-fade-in 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        }

        @keyframes festive-fade-in {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(50px) scale(0.9);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
        }

        .notification-card {
          position: relative;
          background: linear-gradient(145deg, #fff9e6, #ffdab9);
          border: 5px solid #d32f2f;
          border-radius: 20px;
          padding: 2rem 2.5rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2), 
                      inset 0 0 15px rgba(255, 255, 255, 0.5);
          min-width: 400px;
          max-width: 500px;
          overflow: hidden;
        }

        .notification-card::before {
          content: " ";
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 20px;
          background: #3e2723;
          border-radius: 5px;
        }
        
        .notification-card::after {
            content: " ";
            position: absolute;
            top: -25px;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 20px;
            background: #ffd700;
            border-radius: 50%;
            box-shadow: 0 0 10px #ffd700;
        }

        .close-button {
          position: absolute;
          top: 0.75rem;
          right: 0.75rem;
          padding: 0.5rem;
          background: rgba(211, 47, 47, 0.2);
          border: 1px solid #d32f2f;
          border-radius: 50%;
          color: #d32f2f;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 10;
        }

        .close-button:hover {
          background: rgba(211, 47, 47, 0.4);
          transform: rotate(90deg) scale(1.1);
          box-shadow: 0 0 15px rgba(211, 47, 47, 0.6);
        }

        .notification-content {
          position: relative;
          z-index: 5;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          text-align: center;
        }

        .notification-title {
          font-family: 'Cabin Sketch', cursive;
          font-size: 2.2rem;
          color: #1b5e20;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
          margin-bottom: 0.5rem;
        }

        .notification-emoji {
          font-size: 3.5rem;
          
          filter: drop-shadow(0 5px 10px rgba(0,0,0,0.2));
        }

        @keyframes jingle {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(8deg); }
          75% { transform: rotate(-8deg); }
        }

        .points-display {
            font-family: 'Cabin Sketch', cursive;
            font-size: 1.5rem;
            font-weight: 700;
            color: #d32f2f;
            text-shadow: 0 0 8px rgba(255, 215, 0, 0.8);
            padding: 0.5rem 1.5rem;
            background: rgba(255, 215, 0, 0.3);
            border: 2px dashed #d32f2f;
            border-radius: 15px;
            
        }
        
        @keyframes points-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .festive-decoration {
          position: absolute;
          opacity: 0.3;
          pointer-events: none;
          font-size: 3rem;
        }

        .festive-decoration.left {
          left: 15px;
          top: 25%;
          transform: rotate(-15deg);
        }

        .festive-decoration.right {
          right: 15px;
          bottom: 25%;
          transform: rotate(15deg);
        }

        @media (max-width: 640px) {
            .notification-card {
                min-width: 320px;
                max-width: 90vw;
                padding: 1.5rem;
            }
            .notification-title {
                font-size: 1.8rem;
            }
            .notification-emoji {
                font-size: 3rem;
            }
            .points-display {
                font-size: 1.2rem;
            }
        }
      `}</style>

      <div className="christmas-notification-wrapper">
        <div className="notification-card">
          <div className="festive-decoration left">🎄</div>
          <div className="festive-decoration right">🎁</div>
          
          <button
            onClick={onClose}
            className="close-button"
            aria-label="Close notification"
          >
            <X size={18} />
          </button>

          <div className="notification-content">
            <div className="notification-emoji">🎉</div>
            <h3 className="notification-title">Success!</h3>
            {pointsEarned && (
              <div className="points-display">
                +{pointsEarned} Points!
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessNotification;